module.exports = __webpack_public_path__ + "static/media/Té Helado de Mango con Fresas.ccb4ab3d.webp";